import { BlockedValueModalTranslations } from "./blocked-value-modal-pt-br";

export const BLOCKED_VALUE_MODAL_EN_US: BlockedValueModalTranslations = {
	title: "Blocked Value",
	description: "What are blocked values?",
	descriptionText:
		"Blocked values are amounts temporarily unavailable due to security policies or transaction processing.",
	totalSummary: "Total Summary",
	liquidationDate: "LIQUIDATION DATE",
	competenceDate: "COMPETENCE DATE",
	type: "TYPE",
	category: "CATEGORY",
	observation: "OBSERVATION",
	value: "VALUE",
	blockTypes: {
		"Bloqueio automático": "Automatic block",
		"Bloqueio manual": "Manual block",
		"Cessão de recebíveis": "Assignment of receivables",
	},
	blockCategories: {
		"Transferência de titularidade": "Ownership transfer",
		"Ônus - Cessão fiduciária": "Encumbrance - Fiduciary assignment",
		"Ônus - Outros": "Encumbrance - Others",
		"Bloqueio judicial": "Judicial block",
		"Promessa de Cessão": "Assignment promise",
		"Tipo desconhecido": "Unknown type",
	},
	blockObservationPrefixes: {
		"CNPJ do solicitante:": "Applicant's CNPJ:",
	},
};
